import GetLastTest from './Get-last-test';
import AvailableTests from './Available-tests';
import ApplicationForm from './Application-form';
import { ru } from '../../data/ru';
import { by } from '../../data/by';
import './student.css'
import ProfileHeader from '../ProfileHeader';

const Student = ()=>{
	let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdFour: by.RoleIdFour;

	return (
		<>
			<div className='profile_content'>
				<div className='profile_block_cont'>
					<ProfileHeader/>
					{/* <h2 className='student_text_result'>Результат:</h2>
					<div className='student_result_test'> */}
						<GetLastTest userId={localStorage.getItem('id')}/>
					{/* </div> */}
					<h2 className='student_text_next'>{language.availableForPassage}:</h2>
					<div className='student_test_anket'>
						<AvailableTests/>
						{/*<ApplicationForm/>*/}
					</div>
				</div>
			</div>
		</>
	)
}

export default Student;